<template>
    <edit
        :addUrl="'/add/Cancer'"
        :editUrl="'/edit/Cancer'"
        :layerData="layerData"
        :formData="formData"
        :formItemRules="formItemRules"
        :beforeEdit="beforeEdit"
    >
        <template v-slot:content="{formDataProxy, validateInfos}">
            <a-form-item label="癌症名称" name="name" v-bind="validateInfos.name">
                <a-input
                    v-model:value="formDataProxy.name"
                    placeholder="请输入癌症名称"
                    :disabled="layerData.viewFlag"
                />
            </a-form-item>
        </template>
    </edit>
</template>

<script lang="ts">
import {
    defineComponent,
    onBeforeMount,
    onMounted,
    reactive,
    ref,
    toRaw
} from "vue";
import Edit from "@/components/cigo-admin-core/pages/template/Edit.vue";
import cigoLayer from "@/components/cigo-layer";

export default defineComponent({
    name: "EditCancer",
    components: {
        Edit
    },
    props: {
        layerData: {
            type: Object,
            default: {}
        }
    },
    setup(props, ctx) {
        let formData = {
            id: props.layerData.recordCurr
                ? props.layerData.recordCurr.id
                : null,
            name: props.layerData.recordCurr
                ? props.layerData.recordCurr.name
                : ""
        };
        const formItemRules = {
            name: [
                {
                    required: true,
                    message: "请输入癌症名称"
                }
            ]
        };

        return {
            formData,
            formItemRules
        };
    }
});
</script>
